import React from 'react'
import { GetStaticProps, InferGetStaticPropsType } from "next";
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useTranslation } from "next-i18next";
import { useAppSelector } from '@/redux/app/hooks';
import { isTryDemoViewableRedux } from '@/redux/slices/user-context';
import styles from '@/styles/WorkManagement.module.css'
import ColorPalette from './images/colorPalette'
import StoneityButton from '@/components/stoneity-button/stoneityButton'
import Link from 'next/link'
import { useRouter } from 'next/router';
import PageSeo from '@/components/seo/PageSeo';

const Promo = (_props: InferGetStaticPropsType<typeof getStaticProps> & { product?: string }) => {
  const { t } = useTranslation('common');
  const isTryDemoViewable = useAppSelector(isTryDemoViewableRedux);
  const router = useRouter();
  const isPromoPage = router.pathname === "/promo";

  return (
    <>
      {isPromoPage && (
        <PageSeo
          title={`Stoneity Promo | Stoneity`}
          description={router.locale === "tr"
            ? "Stoneity'nin sunduğu değerleri, ücretsiz deneme fırsatını ve plan seçeneklerini keşfedin."
            : "Explore Stoneity's value proposition, free trial opportunity, and available plan options."
          }
          locale={router.locale}
          keywords={router.locale === "tr"
            ? "Stoneity promo, ücretsiz deneme, plan seçenekleri"
            : "Stoneity promo, free trial, plan options"
          }
        />
      )}
      <div className={styles.pageFlex}>
        <div className={styles.promoWrapper}>
          <ColorPalette />
          <span className={styles.title}>{t('customerSatisfactionWithStoneity')}</span>
          <div className={styles.buttonWrapper}>
            {isTryDemoViewable &&
              <Link className={styles.link} href={'/try-demo'}>
                <StoneityButton
                  buttonStyle="dark"
                  buttonText={t('tryItForFree')}
                  width={200}
                  height={45}
                />
              </Link>
            }
            <Link className={styles.link} href={`/${_props.product}/plan`}>
              <StoneityButton
                buttonStyle="light"
                buttonText={t('viewPlan')}
                width={200}
                height={45}
              />
            </Link>
          </div>
        </div>
      </div>
    </>
  )
}

export const getStaticProps: GetStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale || 'en', ['common'])),
  },
});

export default Promo;
